interface StoreDownloadLabels {
  readonly group: string;
  readonly availableOn: string;
  readonly googlePlay: string;
  readonly appStore: string;
  readonly comingSoon: string;
}

interface StoreDownloadLinksProps {
  readonly googlePlayUrl: string;
  readonly appStoreUrl?: string | undefined;
  readonly labels: StoreDownloadLabels;
}

export function StoreDownloadLinks({
  googlePlayUrl,
  appStoreUrl,
  labels,
}: StoreDownloadLinksProps) {
  return (
    <div className="store-links" aria-label={labels.group}>
      <a className="store-link" href={googlePlayUrl} target="_blank" rel="noreferrer">
        <span className="store-link-kicker">{labels.availableOn}</span>
        <strong>{labels.googlePlay}</strong>
      </a>

      {appStoreUrl ? (
        <a className="store-link" href={appStoreUrl} target="_blank" rel="noreferrer">
          <span className="store-link-kicker">{labels.availableOn}</span>
          <strong>{labels.appStore}</strong>
        </a>
      ) : (
        <span className="store-link store-link-unavailable" aria-disabled="true">
          <span className="store-link-kicker">{labels.comingSoon}</span>
          <strong>{labels.appStore}</strong>
        </span>
      )}
    </div>
  );
}
